import { useMemo, useState } from "react";
import { FormattedMessage } from "react-intl";
import { connect, useSelector } from "react-redux";
import { Link, Navigate } from "react-router-dom";
import useSwr from "swr";
import { get, getAccessToken, post } from "../../../api";
import { getCrossDomainTopHref } from "../../../redux/settings/settingsReducer";
import LogoRender from "../../cmp/LogoRender";
import Spinner from "../../cmp/Spinner";
import FormattedHelmet from "../../cmp/intl/FormattedHelmet";
import StyledButton from "../../cmp/themed/StyledButton";
import PlanCard from "./components/PlanCard";
import { ShopifyOrderListener } from "./components/ShopifyTestForPurchase";

function SubscribePayment() {
  const affiliate_id = useSelector((state) => state.settings.affiliate_id);
  const url = useMemo(() => {
    const ids =
      new URLSearchParams(window.location.search).get("id") || undefined;
    return ids ? `/paymentplans?id=${ids || ""}` : "/paymentplans";
  }, []);
  const { data, isLoading: arePlansLoading } = useSwr(
    affiliate_id ? url : null,
    get,
  );
  const membership_plans = data?.plans;
  const [loading, setLoading] = useState(false);
  const [planId, setPlanId] = useState(null);
  const [error, setError] = useState(null);
  const currentPlanId = () => {
    const morethanone = membership_plans.length > 1;
    return planId || (morethanone ? undefined : membership_plans[0].plan_id);
  };

  const onActivate = async (plan_id) => {
    setLoading(true);
    setPlanId(plan_id);
    setError(false);
    console.log("Activating plan", plan_id, await getCrossDomainTopHref());
    post("/paymentplans/payment_url", {
      cancel_url: await getCrossDomainTopHref(),
      plan_id,
    }).then((data) => {
      setLoading(false);
      const { payment_gateway, error } = data;
      if (error) {
        setError(error);
        return;
      }
      if (payment_gateway === "stripe") {
        if (window.top !== window.self) {
          window.top.location = data.session.url;
        } else {
          document.location = data.session.url;
        }
      } else if (payment_gateway === "paypal") {
        const { approve } = data;
        if (window.top !== window.self) {
          window.top.location = approve;
        } else {
          document.location = approve;
        }
      } else if (data?.url) {
        // nuvei payment gateway
        // console.log(data);
        // return;
        if (data?.method === "POST") {
          const form = document.createElement("form");
          form.method = "POST";
          form.action = data.url;
          form.style.display = "none";
          if (data.params) {
            Object.entries(data.params).forEach(([key, value]) => {
              const inp = document.createElement("input");
              inp.name = key;
              inp.value = value;
              form.appendChild(inp);
            });
          }
          document.body.appendChild(form);
          form.submit();
          return;
        }
        if (window.top !== window.self) {
          window.top.location = data.url;
        } else {
          document.location = data.url;
        }
      }
    });
  };

  if (!affiliate_id) {
    return (
      <Navigate
        to={
          "/login?next=" + document.location.pathname + document.location.search
        }
        replace={true}
      />
    );
  }
  if (!membership_plans) {
    if (arePlansLoading) {
      return <BigCentralSpinner />;
    }
    return null;
  }
  if (Array.isArray(membership_plans) && membership_plans.length === 0) {
    return (
      <p className={"text-center"}>
        No membership plans configured for this user
      </p>
    );
  }
  if (!getAccessToken()) {
    return (
      <p className={"text-danger"}>Error: You are currently not logged in.</p>
    );
  }
  const num_plans = membership_plans.length;

  return (
    <VerticalCenterContainer>
      <ShopifyOrderListener />
      <FormattedHelmet id={"Activate membership"} />
      <div className={"container my-4 py-4"}>
        <div className="text-center">
          <LogoRender />
        </div>
        <h3 className={"text_on_bg text-center mt-4 mb-4"}>
          <FormattedMessage id={"Activate membership"} />
        </h3>
        {error && <p className={"text-danger text-center"}>{error}</p>}
        <div
          className={
            "row row-cols-1 g-2 row-cols-md-2 row-cols-lg-3 justify-content-center"
          }
        >
          {membership_plans.map((item) => {
            const cls = Math.max(4, Math.min(12 / num_plans, 6));
            return (
              <div
                className={"col d-flex flex-row"}
                id={`plan-${String(item.plan_id)}`}
                key={String(item.plan_id)}
              >
                <PlanCard
                  loading={loading}
                  isChosen={item.plan_id === planId}
                  {...item}
                  num_plans={num_plans}
                  onChoose={() => onActivate(item.plan_id)}
                />
              </div>
            );
          })}
        </div>
        {currentPlanId() &&
          num_plans === 1 &&
          membership_plans.some((a) => a.plan_type !== "one_time_purchase") && (
            <div className={"text-center mt-2"}>
              {error && <p className={"text-danger"}>{error}</p>}
              <StyledButton
                // className={"btn btn-primary"}
                loading={loading}
                onClick={() => onActivate(currentPlanId())}
              >
                <FormattedMessage id={"Continue"} />
              </StyledButton>
            </div>
          )}
        <div className="mt-4 text-center activate_membership_logout">
          <small>
            <Link to={"/logout"}>
              <FormattedMessage id={"Logout"} />
            </Link>
          </small>
        </div>
      </div>
    </VerticalCenterContainer>
  );
}

function BigCentralSpinner() {
  return (
    <VerticalCenterContainer>
      <Spinner size={"lg"} />
    </VerticalCenterContainer>
  );
}

function VerticalCenterContainer({ children }) {
  return (
    <div className="bg-light-subtle min-vh-100 d-flex align-items-center justify-content-center">
      {children}
    </div>
  );
}

function mapStateToProps(state) {
  return {
    name: state.settings.name,
    email: state.settings.email,
  };
}

export default connect(mapStateToProps)(SubscribePayment);
